import { Spinner } from '@stone-payments/jade'

export function InvestmentsLoading() {
  return (
    <div className="flex items-center justify-center h-full">
      <Spinner size="xlarge" />
    </div>
  )
}
